// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.apps-store-view[data-v-3db6e5ce]{width:100%;display:flex;flex-wrap:wrap}`, "",{"version":3,"sources":["webpack://./src/components/Apps/AppList.vue"],"names":[],"mappings":"AACA,kCACC,UAAA,CACA,YAAA,CACA,cAAA","sourcesContent":["\n.apps-store-view {\n\twidth: 100%;\n\tdisplay: flex;\n\tflex-wrap: wrap;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
